var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBookmarksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bookmarks_floating_icon",
    "data-name": "Bookmarks floating icon",
    transform: "translate(-2054 -373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5321",
    "data-name": "Rectangle 5321",
    transform: "translate(2054 373)",
    fill: "none",
    stroke: "#f60",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0H66a0,0,0,0,1,0,0V56a0,0,0,0,1,0,0H28A28,28,0,0,1,0,28v0A28,28,0,0,1,28,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,.5H65.5a0,0,0,0,1,0,0v55a0,0,0,0,1,0,0H28A27.5,27.5,0,0,1,.5,28v0A27.5,27.5,0,0,1,28,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bookmarks_filled_icon",
    "data-name": "Bookmarks filled icon",
    transform: "translate(79 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5324",
    "data-name": "Rectangle 5324",
    width: 24,
    height: 24,
    transform: "translate(1996 374)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bookmarks-fill-svgrepo-com",
    transform: "translate(1996 374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34314",
    "data-name": "Path 34314",
    d: "M19,1H8.99A2,2,0,0,0,7,3H17a2.006,2.006,0,0,1,2,2V18l2,1V3A2.006,2.006,0,0,0,19,1Z",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34315",
    "data-name": "Path 34315",
    d: "M5,5H15a2.006,2.006,0,0,1,2,2V23l-7-3L3,23V7A2.006,2.006,0,0,1,5,5Z",
    fill: "#f60"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBookmarksIcon);
export default __webpack_public_path__ + "static/media/newBookmarksIcon.837132941a7ba7aba4a2015e84e1513e.svg";
export { ForwardRef as ReactComponent };